// DS: C16A
// DS: CR52
/** Displays a whole thread of comments and post box */ import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import OffsetTrackingCommentThread from './presets/OffsetTrackingCommentThread';
import SimpleThread from './presets/SimpleThread';
import ModalThread from './presets/ModalThread';
import CardLayoutThread from './presets/CardLayoutThread';
// this component is now just a shell for existing usages - if adding a new
// thread, go directly for one of the presets instead
const CommentThread = (_param)=>{
    var { enableOffsetTracking, isModal, useCardLayout } = _param, props = _object_without_properties(_param, [
        "enableOffsetTracking",
        "isModal",
        "useCardLayout"
    ]);
    if (isModal) {
        return /*#__PURE__*/ React.createElement(ModalThread, props);
    }
    if (useCardLayout) {
        return /*#__PURE__*/ React.createElement(CardLayoutThread, props);
    }
    if (enableOffsetTracking) {
        return /*#__PURE__*/ React.createElement(OffsetTrackingCommentThread, props);
    }
    return /*#__PURE__*/ React.createElement(SimpleThread, props);
};
CommentThread.displayName = 'CommentThread';
export default CommentThread;
